
import { AocScoreCategory } from "API/Generated/AocScoreCategory";
import { AocTypes } from "API/Generated/AocTypes";
import { PageantAvailableEvent } from "API/Generated/PageantAvailableEvent";

import { AOCScoringCategoryModel, AreaOfCompetitionTypeBaseModel, PageantAvailableAOCAddEditDTO, PageantAvailableEventModel, ScoringCategoryModel, } from "API/Generated/data-contracts";
import { makeObservable, observable, action, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";

export type DeleteAocScoringCategoryResult = {
  ok: true;
} | {
  ok: false;
  status?: number;
  message?: string;
  detail?: string;
};

class PageantAOCStore {
  PageantAvailabeEventService: PageantAvailableEvent = new PageantAvailableEvent();
  AreasOfCompetitionTypeService: AocTypes = new AocTypes();
  AOCScoringCategoryService: AocScoreCategory = new AocScoreCategory();
  AOCTypeList: AreaOfCompetitionTypeBaseModel[];
  ScoringCategoryList: ScoringCategoryModel[] = [];

  ShowModal: boolean = false;
  AllowEdit: boolean = false;
  AOCScoringCategories: { [key: number]: AOCScoringCategoryModel[] } = {};

  constructor(aocTypeList: AreaOfCompetitionTypeBaseModel[]) {
    makeObservable(this, {
      AOCTypeList: observable,
      ScoringCategoryList: observable,
      AOCScoringCategories: observable,
      ShowModal: observable,
      AllowEdit: observable,
      // getAOCScoringCategories: action,
      addAOCScoringCategory: action,
      deleteAOCScoringCategory: action,
      getScoringCategories: action,
    })
    makePersistable(this, { name: 'PageantAOCStore', properties: ['AOCTypeList', 'ShowModal', 'AllowEdit', 'ScoringCategoryList', 'AOCScoringCategories'] });

    this.AOCTypeList = aocTypeList;
  }

  async getAOCTypes() {
    try {
      const areasOfCompetitionTypeResult = await this.AreasOfCompetitionTypeService.getAreaOfCompetitionTypes();
  
      if (areasOfCompetitionTypeResult?.data?.data) {
        // Ensure unique entries based on ID
        const uniqueAOCList = Array.from(
          new Map(areasOfCompetitionTypeResult.data.data.map((item) => [item.id, item])).values()
        );
  
        // Log duplicate IDs for debugging (optional)
        const ids = areasOfCompetitionTypeResult.data.data.map((item) => item.id);
        const duplicateIds = ids.filter((id, index) => ids.indexOf(id) !== index);
        if (duplicateIds.length > 0) {
          console.warn("Duplicate AOC IDs found:", duplicateIds);
        }
  
        this.AOCTypeList = uniqueAOCList;
      } else {
        console.warn("No data found in AreasOfCompetitionTypeService response.");
        this.AOCTypeList = [];
      }
    } catch (error) {
      console.error("Error fetching AOC types:", error);
      this.AOCTypeList = []; // Set a safe default
    }
  }
  
  

  async saveAOC(model: PageantAvailableEventModel): Promise<boolean> {
    try {
      var aocResult = await this.PageantAvailabeEventService.savePageantAvailableEvent(model);
      if (aocResult.data.data) {
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error: " + JSON.stringify(error));
      return false;
    }
  }

  async deleteAOC(id: number): Promise<boolean> {
    try {
      console.log("deleteAOC", id);
      var aocResult = await this.PageantAvailabeEventService.deletePageantAvailableEvent(id);
      if (aocResult.data.data) {
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error: " + JSON.stringify(error));
      return false;
    }
  }

  //---------New add/update AOC - testing
  async addAOCv2(pageantId: number, dto: PageantAvailableAOCAddEditDTO) {
  try {
    const res = await this.PageantAvailabeEventService.addPageantAvailableAoc(pageantId, dto);
    return res?.data?.data ?? null; // return created PageantAvailableEventModel
  } catch (error) {
    console.error('addAOCv2 error', error);
    return null;
  }
}

async updateAOCv2(
  pageantId: number,
  eventId: number,
  dto: PageantAvailableAOCAddEditDTO,
  replacePackages = true
) {
  try {
    const res = await this.PageantAvailabeEventService.updatePageantAvailableAoc(
      pageantId,
      eventId,
      dto,
      { replacePackages }   // ✅ fix
    );
    return res?.data?.data ?? null;
  } catch (error) {
    console.error('updateAOCv2 error', error);
    return null;
  }
}



  async removeAOCAndCorrespondingPackagesAndContestants(
    pageantId: number,
  eventId: number,): Promise<boolean> {
    try {
      console.log("deleting AOC", eventId);
      var aocResult = await this.PageantAvailabeEventService.deletePageantAvailableAoc(pageantId, eventId);
      if (aocResult) {
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error: " + JSON.stringify(error));
      return false;
    }
  }


    //-------------Update Compete Order----------------
async updateAOCCompeteOrderBulk(
  updates: { id: number; competeOrder: number | null }[]
): Promise<boolean> {
  try {
    const res = await this.PageantAvailabeEventService.updateAocCompeteOrderCreate(updates);
    const ok = typeof res?.ok === 'boolean' ? res.ok : (res?.status >= 200 && res?.status < 300);
    if (!ok) throw new Error('Failed to update compete orders');
    return true;
  } catch (err) {
    console.error('❌ Error during compete order update:', err);
    return false;
  }
}



//   async removeAOCAndCorrespondingPackagesAndContestants2(
//   pageantId: number,
//   eventId: number
// ): Promise<boolean> {
//   try {
//     const res = await this.PageantAvailabeEventService.deletePageantAvailableAoc(pageantId, eventId);

//     // Adjust this guard to match your API shape:
//     // Many of your calls use res?.data?.data for the real payload.
//     const ok =
//       res?.data?.data === true ||          // preferred: ApiResult<bool> pattern
//       res?.data === true ||                // if controller returns plain bool
//       res?.status === 200;                 // fallback if no payload

//     if (!ok) return false;

//     // Keep client state in sync (optional but nice)
//     runInAction(() => {
//       const p = this.PageantStore?.CurrentPageant;
//       if (!p) return;

//       // Remove the AOC itself
//       if (p.pageantAvailableAOC) {
//         p.pageantAvailableAOC = p.pageantAvailableAOC.filter(e => e.id !== eventId);
//       }

//       // Clean package links client-side (if you keep them cached)
//       p.pageantAvailablePackages?.forEach(pkg => {
//         pkg.pageantAvailablePackageToPageantAvailableEvents =
//           (pkg.pageantAvailablePackageToPageantAvailableEvents || [])
//             .filter(link => link.pageantAvailableEventId !== eventId);
//       });

//       // Clean contestant selections client-side (if cached)
//       p.registeredPageantContestants?.forEach(rc => {
//         rc.registeredContestantSelectedEvents =
//           (rc.registeredContestantSelectedEvents || [])
//             .filter(sel => sel.pageantAvailableEventId !== eventId);
//       });
//     });

//     return true;
//   } catch (error) {
//     console.error("removeAOCAndCorrespondingPackagesAndContestants error", error);
//     return false;
//   }
// }



  async getScoringCategories(): Promise<ScoringCategoryModel[]> {
    try {
      const response = await this.AOCScoringCategoryService.getAllScoringCategoriesList();
      const categories = response.data;  // Assuming `data` contains the ScoringCategoryModel array
      runInAction(() => {
        this.ScoringCategoryList = categories || [];
      });
      return this.ScoringCategoryList;  // Return the fetched categories
    } catch (error) {
      console.error("Error fetching scoring categories:", error);
      return [];  // Return an empty array in case of error
    }
  }


  //Unused
  // async getAOCScoringCategories(pageantAvailableEventId: number) {
  //   try {
  //     var result = await this.AOCScoringCategoryService.byAocDetail(pageantAvailableEventId);
  //     if (result.data) {
  //       this.AOCScoringCategories[pageantAvailableEventId] = result.data;
  //     }
  //   } catch (error) {
  //     console.log("Error: " + JSON.stringify(error));
  //   }
  // }

  // async addAOCScoringCategory(model: AOCScoringCategoryModel) {
  //   try {
  //     if (model.pageantAvailableEventId === undefined) {
  //       throw new Error("pageantAvailableEventId is required to add a scoring category.");
  //     }

  //     await this.AOCScoringCategoryService.aocScoreCategoryCreate(model);

  //     if (!this.AOCScoringCategories[model.pageantAvailableEventId]) {
  //       this.AOCScoringCategories[model.pageantAvailableEventId] = [];
  //     }

  //     this.AOCScoringCategories[model.pageantAvailableEventId].push(model);
  //   } catch (error) {
  //     console.log("Error: " + JSON.stringify(error));
  //   }
  // }

async deleteAOCScoringCategory(id: number): Promise<DeleteAocScoringCategoryResult> {
  try {
    await this.AOCScoringCategoryService.deleteAocScoreCategory(id); // 204 on success
    return { ok: true };
  } catch (error: any) {
    const status  = error?.response?.status;
    const message = error?.response?.data?.message ?? error?.message ?? 'Delete failed.';
    const detail  = error?.response?.data?.detail;

    // (Optional) log for devs
    console.log('DeleteAOCScoreCategory error', { status, message, detail });

    return { ok: false, status, message, detail };
  }
}


async deleteAOCScoringCategoryById(id: number): Promise<void> {
  await this.AOCScoringCategoryService.deleteAocScoreCategory(id);
}

  async addAOCScoringCategory(model: AOCScoringCategoryModel): Promise<void> {
    try {
        if (model.pageantAvailableEventId === undefined) {
            throw new Error("pageantAvailableEventId is required to add a scoring category.");
        }

        await this.AOCScoringCategoryService.aocScoreCategoryCreate(model);

        // Ensure the key exists in the object
        if (!this.AOCScoringCategories[model.pageantAvailableEventId]) {
            this.AOCScoringCategories[model.pageantAvailableEventId] = [];
        }

        // Push the new category to the list
        this.AOCScoringCategories[model.pageantAvailableEventId].push(model);
    } catch (error) {
        console.log("Error: " + JSON.stringify(error));
    }
}


async getAOCScoringCategoriesByAOCId(pageantAvailableEventId: number): Promise<AOCScoringCategoryModel[]> {
  try {
    if (!pageantAvailableEventId || typeof pageantAvailableEventId !== 'number') {
      console.error(`Invalid AOC ID: ${pageantAvailableEventId}`);
      return [];
    }

    const result = await this.AOCScoringCategoryService.byAocGetAocScoreCategoriesByAocIdDetail(pageantAvailableEventId);
    console.log(`API result for AOC ID ${pageantAvailableEventId}:`, result);  // Log full result

    if (result.data) {
      runInAction(() => {
        this.AOCScoringCategories[pageantAvailableEventId] = result.data;
      });
      return result.data;
    } else {
      console.warn(`No data received for AOC ID: ${pageantAvailableEventId}`);
      return [];
    }
  } catch (error) {
    console.error(`Error fetching scoring categories for AOC ID ${pageantAvailableEventId}:`, JSON.stringify(error));
    return [];
  }
}









  async setShowModal(show: boolean) {
    console.log("setShowModal", show);
    this.ShowModal = show;
  }

  async setAllowEdit(allow: boolean) {
    this.AllowEdit = allow;
  }
}

let pageantAOCStore: PageantAOCStore;

export function GetPageantAOCStore() {
  if (pageantAOCStore == null) {
    pageantAOCStore = new PageantAOCStore([]);
  }
  return pageantAOCStore;
}